import { render, staticRenderFns } from "./SubEvent.vue?vue&type=template&id=654fc2b7&scoped=true&"
import script from "./SubEvent.vue?vue&type=script&lang=js&"
export * from "./SubEvent.vue?vue&type=script&lang=js&"
import style0 from "./SubEvent.vue?vue&type=style&index=0&id=654fc2b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654fc2b7",
  null
  
)

export default component.exports